// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:21:52

export default {
  "id": "fashion-battle-for-survival",
  "slug": "fashion-battle-for-survival",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/56220d1f1e96477baa832d0403dc6270-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/56220d1f1e96477baa832d0403dc6270/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fashion Battle for Survival",
      "description": "In this puzzle game you have to test your memory by guessing the cards in pairs. Each correctly guessed pair brings you closer to winning the game round. And each successfully completed round opens the doors to the world of fashion, allowing you to dress up the main character of the game - an Asian beauty with a daring character. Remember that the time to complete the round is limited by a timer.",
      "instructions": "Help the Asian beauty replenish her wardrobe with new clothes and hairstyles by solving puzzles in the genre of «find a couple». The time to complete each puzzle is limited by a timer. If you do not have time to solve the puzzle in the allotted time, you will lose, but you can try again. At the finish location, you can view all unlocked achievements and take screenshots. Depending on the gaming device, a computer mouse click or a simple touch on touch screens is used to control it.",
      "genres": [
        "Dress-up",
        "Puzzle"
      ],
      "tags": [
        "dress",
        "girls",
        "hairstyle",
        "memory"
      ]
    },
    "zh-CN": {
      "title": "时尚生存之战",
      "description": "在这个益智游戏中，你需要通过猜对成对的卡片来考验你的记忆力。每猜对一对卡片，你就更接近赢得游戏回合。每个成功完成的回合都会为你打开通往时尚世界的大门，让你装扮游戏的主角——一位具有大胆性格的亚洲美女。记住，完成回合的时间受计时器限制。",
      "instructions": "帮助亚洲美女通过解决“找配对”类别的谜题来更新她的衣橱和发型。每个谜题的完成时间都由计时器限制。如果在规定时间内未能解决谜题，您将失败，但可以再次尝试。在终点位置，您可以查看所有解锁的成就并截图。根据游戏设备的不同，使用电脑鼠标点击或简单的触摸屏幕来控制游戏。",
      "genres": [
        "装扮",
        "拼图"
      ],
      "tags": [
        "服装",
        "女孩",
        "发型",
        "记忆"
      ]
    },
    "zh-TW": {
      "title": "時裝生存戰爭",
      "description": "在這款拼圖遊戲中，您必須通過猜對卡片配對來測試您的記憶力。每猜對一對卡片，您就會更接近贏得遊戲回合。每完成一個回合，都會打開通往時尚世界的門，讓您為遊戲的主角——一位具有勇氣的亞洲美女——打扮。記住，完成回合的時間是受計時器限制的。",
      "instructions": "幫助亞洲美女用新衣服和髮型來充實她的衣櫃，透過解謎遊戲「尋找配對」來完成。每個謎題的完成時間受計時器限制。如果你沒有時間在預定的時間內解謎，你將會輸掉，但你可以再次嘗試。在終點位置，你可以查看所有已解鎖的成就並拍攝螢幕圖。根據遊戲裝置的不同，使用電腦滑鼠點擊或觸控螢幕即可控制遊戲。",
      "genres": [
        "裝扮遊戲",
        "謎題遊戲"
      ],
      "tags": [
        "服裝",
        "女孩",
        "髮型",
        "記憶"
      ]
    },
    "zh-HK": {
      "title": "時裝鬥戰求生存",
      "description": "在這款謎題遊戲中，您需要通過猜對卡片配對來挑戰您的記憶力。每猜對一對卡片，都會讓您更接近獲勝遊戲回合。並且每完成一個回合，都會打開通往時尚世界的門，讓您為遊戲的主角——一個具有勇氣的亞洲美女——打扮。記住，完成回合的時間是有限制的，由計時器控制。",
      "instructions": "協助亞洲美女以解謎遊戲形式「尋找配對」為新衣服和髮型充實衣櫃。每個謎題的完成時間受到計時器的限制。如果您沒有時間在指定時間內解謎，您將會輸掉，但可以再次嘗試。在終點位置，您可以檢視所有已解鎖的成就並攝取螢幕截圖。根據遊戲設備的不同，使用電腦滑鼠點擊或觸控螢幕的簡單觸碰來控制遊戲。",
      "genres": [
        "装扮遊戲",
        "謎題遊戲"
      ],
      "tags": [
        "服裝",
        "女孩",
        "髮型",
        "記憶"
      ]
    },
    "ja": {
      "title": "ファッションバトルフォーサバイバル",
      "description": "このパズルゲームでは、カードをペアで推測して記憶を試す必要があります。正しく推測したペア一つずつでゲームのラウンド勝利に一歩近づきます。そして、各ラウンドを成功完遂すると、ファッションの世界への扉が開き、ゲームの主役である大胆なキャラクターのアジアの美女をドレスアップすることができます。ラウンドを完了する時間はタイマーで制限されていますので、覚えておいてください。",
      "instructions": "アジアの美女に新しい服やヘアスタイルで衣装をリフレッシュさせるために、「見つけよう」ジャンルのパズルを解いてください。それぞれのパズルの解決にはタイマーで制限されています。割り当てられた時間内にパズルを解けないと負けますが、再挑戦できます。終了場所では、解除したすべてのアチーブメントを見ることができ、スクリーンショットを撮ることができます。ゲームデバイスによっては、コンピューターモウスのクリックまたはタッチスクリーンでの簡単なタップで操作できます。",
      "genres": [
        "ドレスアップ",
        "パズル"
      ],
      "tags": [
        "ドレス",
        "ガールズ",
        "ヘアスタイル",
        "記憶"
      ]
    },
    "ko": {
      "title": "생존을 위한 패션 전쟁",
      "description": "이 패ازル 게임에서는 기억력을 테스트하여 카드를 짝 맞추어야 합니다. 올바르게 맞춘 짝맞춤이 게임 라운드 승리에 가까워지게 합니다. 그리고 각 라운드를 성공적으로 완료하면 패션의 세계로 문이 열리며, 게임의 주인공 - 무릎을 꿇지 않는 아시아의 아름다움을 갖춘 주인공을 드레스업할 수 있습니다. 라운드를 완료하는 시간은 타이머에 의해 제한되기 때문에 기억해 두세요.",
      "instructions": "아시아 미녀가 새 옷과 머리 스타일을 채우기 위해 «사진 찾기» 장르의 퍼즐을 풀어주세요. 각 퍼즐을 완료하는 데 걸리는 시간은 타이머에 의해 제한됩니다. 할당된 시간 내에 퍼즐을 풀지 못하면 패배합니다만, 다시 시도할 수 있습니다. 완료 위치에서는 해금된 모든 업적을 확인하고 스크린샷을 찍을 수 있습니다. 게임 장치에 따라 컴퓨터 마우스 클릭이나 태치스크린에의 단순한 터치를 사용하여 제어합니다.",
      "genres": [
        "의상 갈아입기",
        "퍼즐"
      ],
      "tags": [
        "드레스",
        "여자아이들",
        "머리카락 스타일",
        "기억"
      ]
    },
    "fr": {
      "title": "Combats de Mode pour la Survie",
      "description": "Dans ce jeu de puzzle, vous devez tester votre mémoire en devinant les cartes par paires. Chaque paire correctement devinée vous rapproche de la victoire dans la manche de jeu. Et chaque manche terminée avec succès ouvre les portes du monde de la mode, vous permettant de vêtir le personnage principal du jeu - une beauté asiatique aux caractéristiques audacieuses. N'oubliez pas que le temps pour terminer la manche est limité par un chronomètre.",
      "instructions": "Aidez la beauté asiatique à renouveler son dressing avec de nouveaux vêtements et coiffures en résolvant des puzzles du genre \"trouvez un couple\". Le temps pour résoudre chaque puzzle est limité par un chronomètre. Si vous n'avez pas le temps de résoudre le puzzle dans le temps alloué, vous perdez, mais vous pouvez essayer à nouveau. À l'emplacement de finition, vous pouvez consulter tous les trophées déverrouillés et prendre des captures d'écran. Selon le périphérique de jeu, un clic de souris sur un ordinateur ou un simple toucher sur les écrans tactiles est utilisé pour le contrôler.",
      "genres": [
        "Dress-up",
        "Puzzle"
      ],
      "tags": [
        "vêtements",
        "filles",
        "coiffure",
        "mémoire"
      ]
    }
  }
};
